export const required = () => [(v) => !!v || 'Dit veld is verplicht'];
export const required64 = () => [(v) => (v || '').length <= 64 || 'Mag maximum 64 tekens bevatten'];
export const requiredNumber = () => [(v) => v > 0 || 'Dit veld is verplicht en moet groter zijn dan 0'];
